export default {"src":"/_next/static/media/FastShipping.b48fb7d0.svg","height":22,"width":22};